import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { useCheckDncMutation } from "@/store/rest_api";
import { toast } from "sonner";
import React from "react";

interface DncCheckDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function DncCheckDialog({ open, onOpenChange }: DncCheckDialogProps) {
  const [phone, setPhone] = useState("");
  const [result, setResult] = useState<{ doNotCall: boolean; doNotText: boolean; inboundBlocked: boolean } | null>(
    null,
  );
  const [checkDnc, { isLoading }] = useCheckDncMutation();

  const handleCheck = async () => {
    const trimmed = phone.trim();
    if (!trimmed) {
      toast.error("Enter a phone number");
      return;
    }
    try {
      const res = await checkDnc(trimmed).unwrap();
      setResult(res);
    } catch (e: any) {
      toast.error(e?.detail || "Check failed");
    }
  };

  const handleClose = (open: boolean) => {
    if (!open) {
      setPhone("");
      setResult(null);
    }
    onOpenChange(open);
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="max-w-md">
        <DialogTitle>Check Number</DialogTitle>
        <DialogDescription>Check if a phone number is on any Do Not Contact list.</DialogDescription>
        <div className="space-y-4 pt-2">
          <div className="flex gap-2">
            <Input
              placeholder="+1234567890"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleCheck()}
            />
            <Button onClick={handleCheck} disabled={isLoading}>
              {isLoading ? "Checking..." : "Check"}
            </Button>
          </div>

          {result && (
            <div className="border rounded-lg p-4 space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-sm">Do Not Call</span>
                <Badge variant={result.doNotCall ? "destructive" : "secondary"}>
                  {result.doNotCall ? "Blocked" : "Clear"}
                </Badge>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm">Do Not Text</span>
                <Badge variant={result.doNotText ? "destructive" : "secondary"}>
                  {result.doNotText ? "Blocked" : "Clear"}
                </Badge>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm">Inbound calls</span>
                <Badge variant={result.inboundBlocked ? "destructive" : "secondary"}>
                  {result.inboundBlocked ? "Blocked" : "Allowed"}
                </Badge>
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
